export default "__VITE_ASSET__D3D_AdgL__"